// extracted by mini-css-extract-plugin
export default {"modal_wrapper":"modalstyles_modal_wrapper__KnYeR","container":"modalstyles_container__uZX3Q","modal_content":"modalstyles_modal_content__-qVAi"};